export const PASSWORD_RECOVERY_POST = 'PASSWORD_RECOVERY_POST'
export const PASSWORD_SET_POST = 'PASSWORD_SET_POST'
export const PASSWORD_RESET_POST = 'PASSWORD_RESET_POST'
export const PASSWORD_RECOVERY_UPDATE = 'PASSWORD_RECOVERY_UPDATE'
export const PASSWORD_SET_UPDATE = 'PASSWORD_SET_UPDATE'
export const PASSWORD_ERROR = 'PASSWORD_ERROR'

export function postPasswordRecovery(payload = {}) {
  return {
    type: PASSWORD_RECOVERY_POST,
    payload,
  }
}

export function postPasswordSet(payload = {}) {
  return {
    type: PASSWORD_SET_POST,
    payload,
  }
}

export function postPasswordReset(payload = {}) {
  return {
    type: PASSWORD_RESET_POST,
    payload,
  }
}

export function updatePasswordRecovery(payload = {}) {
  return {
    type: PASSWORD_RECOVERY_UPDATE,
    payload,
  }
}

export function updatePasswordSet(payload = {}) {
  return {
    type: PASSWORD_SET_UPDATE,
    payload,
  }
}

export function errorPassword(payload = {}) {
  return {
    type: PASSWORD_ERROR,
    payload,
  }
}
